module.exports = __webpack_public_path__ + "assets/86238b433bfcf608bedbd0bcf61803ac.png";